<template>
<div class="wrapper">

  <v-sidebar activeNavItem="map"></v-sidebar>

    <div class="main-panel">
      <v-navbar :title="'Map'"></v-navbar>

      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col text-right">
              <select v-model="trackerId">
                <option value="AT_003">
                  Dummy Device (AT_003)
                </option>
                <option value="6511">
                  Blue Rover (6511)
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col col-2 points-list">
              <ul>
                <li v-for="(point,index) of points" :key="index">
                  {{ point.tooltip }}
                </li>
              </ul>
            </div>
            <div class="col ">
              <LeafletMap fit-to-markers height="600px" :points="this.points" :lines="this.lines"/>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <input id="startdate" type="text" class="form-control datetimepicker" v-model="startdate">
            </div>
            <div class="col">
              <input id="enddate" type="text" class="form-control datetimepicker" v-model="enddate">
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <button @click="loadBlueRoverData">
                Load Points
              </button>
            </div>
            <div class="col">
              <button @click="resetDateInputs">
                Reset Dates
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>

import apiService from '../../services/api.service';
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'

import LeafletMap from './LeafletMap.vue';
import config from '../../config';
    
export default {
  name: 'MapPage',
  components:{
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    LeafletMap,
  },
  data(){
    return {
      trackerId: '6511',
      startdate: '',
      enddate: '',
      startDate: new Date(),
      endDate: new Date(),
      points:[
        // {
        //   center: [ 43.38341, -80.48548000000001 ]
        // },
        // {
        //   center: [ 43.451027, -80.498166 ]
        // },
        // {
        //   center: [ 43.450696, -80.494341 ]
        // },
      ],
      lines:[
        // {
        //   pointList:[
        //     [ 43.451027, -80.498166 ],
        //     [ 43.450696, -80.494341 ],
        //   ],
        //   options:{
        //     color: 'red',
        //     weight: 3,
        //     opacity: 0.5,
        //     smoothFactor: 1
        //   },
        // }
      ],
    }
  },
  mounted(){
    this.resetDateInputs();
    this.loadBlueRoverData();
    setTimeout(() => {
      initDatePickers('.datetimepicker');
    }, 1000);
  },
  watch: {
    startdate(newVal, oldVal){
      this.startDate = new Date(newVal);
    },
    enddate(newVal, oldVal){
      this.endDate = new Date(newVal);
    }
  },
  methods:{
    resetDateInputs(){
      const now = new Date();
      this.startdate =  new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      this.enddate =  new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    },
    async loadBlueRoverData(){
      const response = await apiService.get(
        `/bluerover/getDynamicData?&deviceId=${this.trackerId}${this.trackerId.startsWith('AT_') ? `&dummyTracker`:''}&startDate=${this.startDate.toISOString()}&endDate=${this.endDate.toISOString()}`
      );
      this.drawPoints(response.data.data);
    },
    drawPoints(data){
      const points = data.filter(point => point.latitude != null && point.longitude != null);
      // console.log("Points", points);
      this.points = points.map(point => {
        const timestamp = new Date(point.timestamp * 1000);
        const padStart = value => (value+"").padStart(2, "0");
        const date = padStart(timestamp.getDate());
        const hours = padStart(timestamp.getHours());
        const min = padStart(timestamp.getMinutes());
        const sec = padStart(timestamp.getSeconds());
        const tooltip = `${date} @ ${hours}:${min}:${sec}`;
        return {
          center: [ point.latitude, point.longitude ],
          tooltip: tooltip,
          popup: `
            Time: ${tooltip} <br />
            temperature: ${point.temperature} <br />
            rssi: ${point.rssi} <br />
            voltage: ${point.voltage} <br />
            sw: ${point.sw} <br />
            flags: ${point.flags} <br />
            rtcTime: ${point.rtcTime} <br />
            altitude: ${point.altitude} <br />
            hdop: ${point.hdop} <br />
            spkm: ${point.spkm} <br />
            status: ${point.status} <br />
          `,
        };
      });
      const pointList = points.map(point => ([ point.latitude, point.longitude ]));
      this.lines = [{
        pointList: pointList,
        options:{
          color: 'red',
          weight: 3,
          opacity: 0.5,
          smoothFactor: 1
        },
      }]
    }
  },
}
</script>
<style scoped>
.points-list{
  overflow: auto;
  max-height: 600px;
  padding: 0;
  margin: 0;
}
.points-list > ul{
  list-style: none;
  font-size: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// MapPage.vue?3315b007